import ActionButton from "@components/controls/HoverController/ActionButton";
import IsMacService from "@core-ui/ContextServices/IsMac";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import toggleSignature from "@core-ui/toggleSignature";
import t from "@ext/localization/locale/translate";
import { Editor } from "@tiptap/core";
import { Node } from "@tiptap/pm/model";
import { Dispatch, RefObject, SetStateAction } from "react";

interface DrawioActionsProps {
	editor: Editor;
	node: Node;
	signatureRef: RefObject<HTMLInputElement>;
	openEditor: () => void;
	setHasSignature: Dispatch<SetStateAction<boolean>>;
}

const DrawioActions = ({ editor, node, setHasSignature, signatureRef, openEditor }: DrawioActionsProps) => {
	const { isTauri } = usePlatform();
	const isMac = IsMacService.value;
	const isDisabled = isTauri && isMac;
	const updateAttributes = (attributes: Record<string, any>) => {
		editor.commands.updateAttributes(node.type, attributes);
	};

	const addSignature = () => {
		setHasSignature((prev) => toggleSignature(prev, signatureRef.current, updateAttributes));
	};

	return (
		<>
			<ActionButton
				disabled={isDisabled}
				icon="pencil"
				tooltipText={isDisabled ? t("diagram.error.not-edit-in-desktop") : t("edit2")}
				onClick={openEditor}
			/>
			<ActionButton icon="captions" tooltipText={t("signature")} onClick={addSignature} />
		</>
	);
};

export default DrawioActions;
